var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfronto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93103 6.27586L1 3.63793M1 3.63793L3.93103 1M1 3.63793L14.4828 3.63794C16.4253 3.63794 18 5.21267 18 7.15518V8.6207M15.069 18L18.0001 15.3621M18.0001 15.3621L15.069 12.7241M18.0001 15.3621L4.51724 15.3621C2.57473 15.3621 1 13.7874 1 11.8448V10.3793",
    stroke: "#353A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfronto);
export default __webpack_public_path__ + "static/media/confronto.d7d4bd851b03b3952d95ea307cdc7707.svg";
export { ForwardRef as ReactComponent };